import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { Login } from '@/components/auth/Login';
import { Sidebar } from '@/components/layout/Sidebar';
import { AppFrame } from '@/components/layout/AppFrame';
import { APPS } from '@/apps/registry';

export function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) {
    return <Login />;
  }

  // Default app: primeira app em status 'wip' ou 'live'.
  // Fallback defensivo se registry estiver vazio (não deveria acontecer
  // em produção, mas pega misconfiguration cedo).
  const defaultApp =
    APPS.find((a) => a.status === 'wip' || a.status === 'live') ?? APPS[0];

  if (!defaultApp) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-100">
        <div className="max-w-md p-6 text-center">
          <h1 className="text-xl font-semibold text-red-400 mb-2">
            Configuração inválida
          </h1>
          <p className="text-sm text-slate-400">
            Nenhuma aplicação disponível no registry. Verifique{' '}
            <code className="text-slate-300">src/apps/registry.ts</code>.
          </p>
        </div>
      </div>
    );
  }

  const defaultPath = `/app/${defaultApp.id}`;

  return (
    <BrowserRouter>
      <div className="min-h-screen flex">
        <Sidebar />
        <main className="flex-1 flex flex-col">
          <Routes>
            <Route path="/" element={<Navigate to={defaultPath} replace />} />
            <Route path="/app/:appId" element={<AppFrame />} />
            <Route path="*" element={<Navigate to={defaultPath} replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
